import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
require('css/components/searchInput.scss');

class SearchInput extends Component {
  static defaultProps = {
    onSearch: () => {},
    onClick: () => {},
    isSearchCommunities: false,
  }

  state = {
    isFocused: false,
  }

  onFocus = () => {
    this.setState({ isFocused: true });
  }

  onBlur = () => {
    this.setState({ isFocused: false });
  }

  onClick = () => {
    this.props.onClick();
  }

  onSubmit = (e) => {
    document.activeElement.blur();
    e.preventDefault();
    this.setState({ isFocused: false });
    this.props.onSearch();

    if (this.props.isSearchCommunities) {
      return window.location.href = `/search/communities?query=${this.input.value}&page=1`;
    } else {
      return window.location.href = `/search/posts?query=${this.input.value}&page=1&community=all`;
    }
  }

  render() {
    const { className } = this.props;
    const containerClassName = classNames({
      [className]: !!className,
      'search-bar__container': true,
      'search-bar__container--focused': this.state.isFocused,
    });
    const placeholder = !!this.props.isSearchCommunities ? 'Enter a condition or a topic' : 'Search HealthUnlocked';

    return (
      <form className={containerClassName} onSubmit={this.onSubmit}>
        <input
          aria-label="Start a search"
          className="search-bar__input"
          placeholder={placeholder}
          ref={node => this.input = node}
          type="text"
          onBlur={this.onBlur}
          onClick={this.onClick}
          onFocus={this.onFocus}
        />
        <button className="btn btn-primary search-bar__icon solo-icon" type="submit" aria-label="Search">
          <span className="icon icon-search-1" />
        </button>
      </form>
    );
  }
}

SearchInput.propTypes = {
  className: PropTypes.string,
  onSearch: PropTypes.func,
  onClick: PropTypes.func,
  isSearchCommunities: PropTypes.bool,
};

export default SearchInput;



// WEBPACK FOOTER //
// ./app/assets/jsx/components/search/searchInput.jsx